import { ReactElement, ReactNode, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader, PageHeaderProps } from '../../components'
import { AgxSpacer, AgxNotes } from '@urbanx/agx.ui-components2'
import { StaffNoteModelCatalogueType } from '@urbanx/agx.staff.client'
import { useContentScroll } from 'contexts'
import './pagelayout.scss'
import clsx from 'clsx'

const HIDE_HEADER_SCROLL_THRESHOLD = 5

export interface PageLayoutProps extends PageHeaderProps {
  children: ReactNode
  header?: ReactElement | ReactElement[]
  transparent?: boolean
}

type PageHeaderHandle = React.ElementRef<typeof PageHeader>

const PageLayout = (props: PageLayoutProps) => {
  const { children, transparent, isStaff, header, isCampaignsSection } = props
  const ref = useRef<PageHeaderHandle>(null)
  const { campaignId } = useParams()
  const { contentScrollPosition } = useContentScroll()

  // In the campaigns section the page header fully collapses on scroll so the
  // pinned tab bar can move to the top and give the content more space.
  const hideHeaderOnScroll =
    isCampaignsSection && contentScrollPosition >= HIDE_HEADER_SCROLL_THRESHOLD
  const pageHeader = (
    <AgxSpacer
      className={clsx(
        'pageHeaderContainer',
        isCampaignsSection && 'pageHeaderContainer-campaignsSection',
        hideHeaderOnScroll && 'pageHeaderContainer-hidden'
      )}
    >
      <AgxSpacer className="pageHeaderSurface" gap="md">
        <PageHeader
          {...props}
          primaryPageTitle={isStaff ? 'URBAN X' : props.primaryPageTitle}
          isCampaignsSection={isCampaignsSection}
          ref={ref}
        />
        {header}
      </AgxSpacer>
    </AgxSpacer>
  )
  return (
    <div
      onClick={() => ref && ref.current && ref.current.closeMenuIfOpen()}
      className={clsx(
        'pageContainer',
        isCampaignsSection && 'pageContainer-campaignsSection'
      )}
    >
      {pageHeader}
      <div className={`pageBody ${transparent ? 'transparent' : ''}`}>
        {children}
      </div>
      {campaignId && (
        <AgxNotes
          catalogueId={campaignId}
          catalogueType={StaffNoteModelCatalogueType.Campaign}
          maxNoteLength={1000}
        />
      )}
    </div>
  )
}

export default PageLayout
